import React from 'react';
import  { useFetchTransactionPost } from '../../hooks/useFetchData';
import Detail from '../../components/shared/Detail';
import Header from '../../components/shared/Header';
import Breadcrumb from '../../components/shared/Breadcrumbs';


const TransactionDetailPage = () => {
  const { data: transaction_post, loading, error } =  useFetchTransactionPost();
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "売買掲示板一覧", path: "/transaction" },
    { label: `${transaction_post.title}`, path: "/transaction/:postId" },

  ]; 

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  const table_list={}
    table_list["カテゴリー"] = transaction_post.things_cat_name;
    if(transaction_post.things_cat_name === '車'){
      table_list["メーカー"] = transaction_post.maker_name || "-";
      table_list["走行距離"] = transaction_post.eileage_name || "-";
    }
  return (
    <div>
    <Header />
    <Breadcrumb items={breadcrumbs} />
    <Detail 
      item={transaction_post} 
      table_list={table_list}
      type="transaction"
    />
    </div>
  );
};

export default TransactionDetailPage;